import { IDateRangeRequestParams } from "Dashboard/domain/IDateRangeRequestParams";
import API from "utils/API";
import authHeader from "utils/auth-header";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IConsumableResponse } from "../domain/IConsumableResponse";
import { IPartnerPayables } from "../domain/IPartnerPayables";
import { IPartnerReceivables } from "../domain/IPartnerReceivables";
import { IResourcesAlarmResponse } from "../domain/IResourceAlarmResponse";
import { IResourceChargeResponse } from "../domain/IResourceChargeResponse";
import { IResourceInspectionResponse } from "../domain/IResourceInspectionResponse";
import { IResourceRefuelResponse } from "../domain/IResourceRefuelResponse";
import { IServiceResponse } from "../domain/IServiceResponse";
import { IStatisticsResponse } from "../domain/IStatisticsResponse";
import { IStockExemptionResponse } from "../domain/IStockExemptionResponse";
import { IStockInputResponse } from "../domain/IStockInputResponse";

const getGeneralStatistics = async (
  data?: IDateRangeRequestParams
): Promise<IStatisticsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IStatisticsResponse>(
      `/daily-table/protected/statistics${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getBasicConsumablesData = async (
  data?: IDateRangeRequestParams
): Promise<IConsumableResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IConsumableResponse>(
      `/daily-table/protected/consumables${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getBasicDataForResourcesWithAlarms =
  async (): Promise<IResourcesAlarmResponse> => {
    var headers = authHeader();
    try {
      const response = await API.get<IResourcesAlarmResponse>(
        "/daily-table/protected/resource-alarm",
        { headers }
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

const getStateOfStockInput = async (): Promise<IStockInputResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IStockInputResponse>(
      "/daily-table/protected/stock-input",
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getBasicDataForServicesOfResources = async (
  data?: IDateRangeRequestParams
): Promise<IServiceResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IServiceResponse>(
      `/daily-table/protected/resource-service${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getBasicDataForChargesOfResources = async (
  data?: IDateRangeRequestParams
): Promise<IResourceChargeResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResourceChargeResponse>(
      `/daily-table/protected/resource-charge${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getStateOfStockExemptions = async (
  data?: IDateRangeRequestParams
): Promise<IStockExemptionResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IStockExemptionResponse>(
      `/daily-table/protected/stock-exemption${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getBasicDataForRefuelsOfResources = async (
  data?: IDateRangeRequestParams
): Promise<IResourceRefuelResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResourceRefuelResponse>(
      `/daily-table/protected/resource-refuel${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getBasicDataForInspectionsOfResources =
  async (): Promise<IResourceInspectionResponse> => {
    var headers = authHeader();
    try {
      const response = await API.get<IResourceInspectionResponse>(
        "/daily-table/protected/resource-inspection",
        { headers }
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

const getPartnerReceivablesWithPayments =
  async (): Promise<IPartnerReceivables> => {
    var headers = authHeader();
    try {
      const response = await API.get<IPartnerReceivables>(
        "/daily-table/protected/partner-receivables",
        { headers }
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

const getPartnerPayablesWithPayments = async (): Promise<IPartnerPayables> => {
  var headers = authHeader();
  try {
    const response = await API.get<IPartnerPayables>(
      "/daily-table/protected/partner-payables",
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const DailyTableService = {
  getGeneralStatistics,
  getBasicConsumablesData,
  getBasicDataForResourcesWithAlarms,
  getStateOfStockInput,
  getStateOfStockExemptions,
  getBasicDataForRefuelsOfResources,
  getBasicDataForChargesOfResources,
  getBasicDataForServicesOfResources,
  getBasicDataForInspectionsOfResources,
  getPartnerReceivablesWithPayments,
  getPartnerPayablesWithPayments,
};
